module.exports = __webpack_public_path__ + "static/media/aw2.776e1882.png";